// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commutably {
  --card-padding-y: 1.5em;
  --card-padding-x: 1.5em;
  --card-heading-margin: 1em;
  --card-elevated-shadow: var(--shadow-3);
  --card-border-radius: 6px;

  --card-paper1-background: white;
  --card-paper1-border: none;
  --card-paper1-text-color: var(--color-grey-6);
  --card-paper1-header-background: var(--color-grey-1);

  --card-paper2-background: var(--color-grey-1);
  --card-paper2-border: none;
  --card-paper2-text-color: var(--color-grey-6);
  --card-paper2-header-background: var(--color-grey-2);

  --card-inverse-background: var(--color-grey-6);
  --card-inverse-border: none;
  --card-inverse-text-color: white;

  --card-accent-background: var(--gradient-purple-1);
  --card-accent-border: none;
  --card-accent-text-color: white;

  --card-info-background: var(--gradient-blue-1);
  --card-info-border: none;
  --card-info-text-color: white;

  --card-success-border: none;
  --card-success-text-color: white;
  --card-success-background: var(--color-green-1);

  --card-warn-border: none;
  --card-warn-text-color: black;
  --card-warn-background: var(--color-yellow-1);

  --card-error-border: none;
  --card-error-text-color: white;
  --card-error-background: var(--gradient-red-1);

  --card-header-font-weight: normal;
}

/* @media (prefers-color-scheme: dark) {
  .commutably {
    --card-paper1-background: var(--color-grey-2);
  }
} */

@media screen and (min-width: 768px) {
  .commutably {
    --card-padding-x: 2em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/theme/components/Card.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,0BAA0B;EAC1B,uCAAuC;EACvC,yBAAyB;;EAEzB,+BAA+B;EAC/B,0BAA0B;EAC1B,6CAA6C;EAC7C,oDAAoD;;EAEpD,6CAA6C;EAC7C,0BAA0B;EAC1B,6CAA6C;EAC7C,oDAAoD;;EAEpD,8CAA8C;EAC9C,2BAA2B;EAC3B,gCAAgC;;EAEhC,kDAAkD;EAClD,0BAA0B;EAC1B,+BAA+B;;EAE/B,8CAA8C;EAC9C,wBAAwB;EACxB,6BAA6B;;EAE7B,2BAA2B;EAC3B,gCAAgC;EAChC,+CAA+C;;EAE/C,wBAAwB;EACxB,6BAA6B;EAC7B,6CAA6C;;EAE7C,yBAAyB;EACzB,8BAA8B;EAC9B,8CAA8C;;EAE9C,iCAAiC;AACnC;;AAEA;;;;GAIG;;AAEH;EACE;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".commutably {\n  --card-padding-y: 1.5em;\n  --card-padding-x: 1.5em;\n  --card-heading-margin: 1em;\n  --card-elevated-shadow: var(--shadow-3);\n  --card-border-radius: 6px;\n\n  --card-paper1-background: white;\n  --card-paper1-border: none;\n  --card-paper1-text-color: var(--color-grey-6);\n  --card-paper1-header-background: var(--color-grey-1);\n\n  --card-paper2-background: var(--color-grey-1);\n  --card-paper2-border: none;\n  --card-paper2-text-color: var(--color-grey-6);\n  --card-paper2-header-background: var(--color-grey-2);\n\n  --card-inverse-background: var(--color-grey-6);\n  --card-inverse-border: none;\n  --card-inverse-text-color: white;\n\n  --card-accent-background: var(--gradient-purple-1);\n  --card-accent-border: none;\n  --card-accent-text-color: white;\n\n  --card-info-background: var(--gradient-blue-1);\n  --card-info-border: none;\n  --card-info-text-color: white;\n\n  --card-success-border: none;\n  --card-success-text-color: white;\n  --card-success-background: var(--color-green-1);\n\n  --card-warn-border: none;\n  --card-warn-text-color: black;\n  --card-warn-background: var(--color-yellow-1);\n\n  --card-error-border: none;\n  --card-error-text-color: white;\n  --card-error-background: var(--gradient-red-1);\n\n  --card-header-font-weight: normal;\n}\n\n/* @media (prefers-color-scheme: dark) {\n  .commutably {\n    --card-paper1-background: var(--color-grey-2);\n  }\n} */\n\n@media (--screen-md) {\n  .commutably {\n    --card-padding-x: 2em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
